import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import s from "./styles";

function SelectRole({ setrolViewList, disabled }) {
  const { t } = useTranslation();
  const [select, setSelect] = useState("all");

  useEffect(() => {
    setrolViewList(select);
  }, [select]);

  return (
    <s.Wrapper>
      <s.WrapperBottomComponents>
        <s.DataSelector disabled={disabled}>
          <s.DateSelectorItem
            selected={select === "all"}
            left
            style={{ borderRadius: "2px 0 0 2px" }}
            onClick={() => setSelect("all")}
          >
            {t("components.common.SelectRole.all")}
          </s.DateSelectorItem>
          <s.DateSelectorItem
            selected={select === "manager"}
            onClick={() => setSelect("manager")}
          >
            {t("components.common.SelectRole.manager")}
          </s.DateSelectorItem>
          <s.DateSelectorItem
            selected={select === "admin"}
            onClick={() => setSelect("admin")}
          >
            {t("components.common.SelectRole.admin")}
          </s.DateSelectorItem>
          <s.DateSelectorItem
            selected={select === "clerk"}
            onClick={() => setSelect("clerk")}
          >
            {t("components.common.SelectRole.clerk")}
          </s.DateSelectorItem>
          <s.DateSelectorItem
            selected={select === "no_tpv"}
            onClick={() => setSelect("no_tpv")}
          >
            {t("components.common.SelectRole.noAccessToPOS")}
          </s.DateSelectorItem>
          <s.DateSelectorItem
            selected={select === "delivery"}
            style={{ borderRadius: "0 2px 2px 0" }}
            onClick={() => setSelect("delivery")}
          >
            {t("components.common.SelectRole.delivery")}
          </s.DateSelectorItem>
        </s.DataSelector>
      </s.WrapperBottomComponents>
    </s.Wrapper>
  );
}

export default SelectRole;
